export interface ViewerRouteOptions {
  pathname?: string;
  embeddedWorldId?: string | null;
  autoMobile?: boolean;
}

export interface MobileLayoutSignals {
  userAgent: string;
  maxTouchPoints: number;
  coarsePointer: boolean;
}

export function shouldUseMobileLayout({
  userAgent,
  maxTouchPoints,
  coarsePointer,
}: MobileLayoutSignals): boolean {
  if (/Mobi|Android|iPhone|iPad|iPod/i.test(userAgent)) return true;
  if (/Macintosh/i.test(userAgent) && maxTouchPoints > 1) return true;
  return coarsePointer && maxTouchPoints > 0;
}

function embedIdFromPath(pathname: string): string | null {
  return /^\/e\/([A-Za-z0-9_-]{10,64})\/?$/.exec(pathname)?.[1] ?? null;
}

/** Neutral viewer routing — single PlayCanvas engine, no engine names in URLs. */
export function parseViewerRoute(
  search: string,
  options: ViewerRouteOptions = {},
): {
  worldId: string | null;
  showIndex: boolean;
  mobileLayout: boolean;
  embedId: string | null;
} {
  const params = new URLSearchParams(search);
  const embedId = embedIdFromPath(options.pathname ?? '/');
  const worldId = embedId ? (options.embeddedWorldId ?? null) : params.get('world');
  const mobileParam = params.get('m') ?? params.get('mobile');
  const mobileLayout =
    mobileParam === '1'
      ? true
      : mobileParam === '0'
        ? false
        : Boolean(embedId && options.autoMobile);
  return { worldId, showIndex: !worldId, mobileLayout, embedId };
}

export function worldViewerHref(worldId: string): string {
  return `/?world=${encodeURIComponent(worldId)}`;
}

/** Edge-to-edge mobile layout — canvas fills the device window (no chrome). */
export function worldMobileViewerHref(worldId: string): string {
  return `/?world=${encodeURIComponent(worldId)}&m=1`;
}
